import { ProductDataVariant } from '../../../services/product/product-data'

export const getProductDescription = (productVariant?: ProductDataVariant) =>
  productVariant?.productLongDescription ||
  productVariant?.productShortDescription ||
  ''
